module.exports = __webpack_public_path__ + "static/media/image_premium_offer.df7ec379.png";